import { Link, NavLink } from "react-router-dom";
import { getLanguageContent } from "../../utils/language/languageSelector";
import { PUBLIC_FOOTER_SCHEMA } from "../../utils/schemas/language/components/publicfooterSchema";

const PublicFooterV2 = ({ langKey }) => {
  const content = getLanguageContent(PUBLIC_FOOTER_SCHEMA, langKey);

  return (
    <footer className="public-v2-footer">
      <div className="footer-v2-main">
        <div className="footer-v2-brand">
          <NavLink to="/" className="public-nav-v2-logo">
            <img
              src={`${process.env.PUBLIC_URL}/images/logo_dark_blue.svg`}
              alt="Plaintr"
              height="30"
            />
          </NavLink>
          <p className="footer-v2-description">{content.description}</p>
        </div>
        <div className="footer-v2-column">
          <h5>{content.col1.heading}</h5>
          <ul className="footer-v2-links">
            <li>
              <Link to="/sign-in">{content.col1.link2.text}</Link>
            </li>
            <li>
              <Link to="/create-cpa">{content.col1.link3.text}</Link>
            </li>
            <li>
              <Link to="/faq">{content.col1.link4.text}</Link>
            </li>
            <li>
              <Link to="/help-center">{content.col1.link5.text}</Link>
            </li>
          </ul>
        </div>
        <div className="footer-v2-column">
          <h5>{content.col2.heading}</h5>
          <ul className="footer-v2-links">
            <li>
              <Link to="/services">{content.col2.link1.text}</Link>
            </li>
            <li>
              <Link to="/who-we-help">{content.col2.link2.text}</Link>
            </li>
            <li>
              <Link to="/blog">{content.col2.link3.text}</Link>
            </li>
          </ul>
        </div>
        <div className="footer-v2-column">
          <h5>{content.col3.heading}</h5>
          <ul className="footer-v2-links">
            <li>
              <Link to="/about-us">{content.col3.link1.text}</Link>
            </li>
          </ul>
          <h5>{content.col3.link2.text}</h5>
          <div className="footer-v2-social-links">
            <Link
              to="https://www.facebook.com/profile.php?id=61580473952631"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-v2-social-link"
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/icons/fb_white.svg`}
                alt="Facebook"
              />
            </Link>
            <Link
              to="https://www.instagram.com/plaintrllc/"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-v2-social-link"
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/icons/inst_white.svg`}
                alt="Instagram"
              />
            </Link>
            <Link
              to="https://www.linkedin.com/company/plaintr"
              target="_blank"
              rel="noopener noreferrer"
              className="footer-v2-social-link"
            >
              <img
                src={`${process.env.PUBLIC_URL}/images/icons/ln_white.svg`}
                alt="LinkedIn"
              />
            </Link>
          </div>
        </div>
      </div>

      <div className="footer-v2-bottom">
        <h6>
          2025 © Plaintr • All rights reserved •{" "}
          <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </Link>{" "}
          •{" "}
          <Link
            to="/terms-conditions"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms & Conditions
          </Link>
        </h6>
      </div>
    </footer>
  );
};

export default PublicFooterV2;
